module.exports = __webpack_public_path__ + "static/img/3.79b70e60.png";